import { createContext, useContext } from "react";
import { ComplianceCaseTypeEnum } from "../../graphql/supergraphTypes";

export type ComplianceContextValue = {
  basePath: string;
  caseId: number;
  caseType: ComplianceCaseTypeEnum;
  arenaId: number;
  rootProfileId: number;
  programId: number;
  skipDetailsForRootProfile: boolean;
  enableLPUXv2: boolean;
  isReadOnly: boolean;
};

export const ComplianceCaseContext = createContext<ComplianceContextValue | undefined>(
  undefined,
);

export const useComplianceCaseContext = () => {
  const ctx = useContext<ComplianceContextValue | undefined>(ComplianceCaseContext);
  if (ctx === undefined) {
    throw new Error(
      "useComplianceCaseContext must be used within an ComplianceCaseContext Provider",
    );
  }
  return ctx;
};
